import React, { useState } from 'react';
import { useMutation } from 'convex/react';
import { api } from '../../convex/_generated/api';

interface PatrolLogCreatorProps {
  vehicle: any;
  site: any;
  onClose: () => void;
  onCreated: () => void;
}

const PatrolLogCreator: React.FC<PatrolLogCreatorProps> = ({ 
  vehicle, 
  site, 
  onClose, 
  onCreated 
}) => {
  const createPatrolLog = useMutation(api.patrolLogs.createPatrolLog);
  
  const [duration, setDuration] = useState('');
  const [notes, setNotes] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!duration.trim()) return;

    setIsSubmitting(true);
    try {
      await createPatrolLog({
        vehicleId: vehicle._id,
        vehicleName: vehicle.displayName,
        siteId: site._id,
        siteName: site.name,
        notes: `${duration.trim()} - ${notes.trim()}` || '',
      });
      
      onCreated();
      onClose();
    } catch (error) {
      console.error('Failed to create patrol log:', error);
      alert('Failed to create patrol log. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        minWidth: '400px',
        maxWidth: '500px',
      }}>
        <h2>Create Patrol Log</h2>
        <p><strong>Vehicle:</strong> {vehicle.displayName}</p>
        <p><strong>Site:</strong> {site.name}</p>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="duration" style={{ display: 'block', marginBottom: '5px' }}>
              Duration *
            </label>
            <input
              id="duration"
              type="text"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              placeholder="e.g., 30 minutes, 2 hours"
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px',
              }}
              required
            />
          </div>
          
          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="notes" style={{ display: 'block', marginBottom: '5px' }}>
              Notes (optional)
            </label>
            <textarea
              id="notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Any additional notes about the patrol..."
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                minHeight: '80px',
                resize: 'vertical',
              }}
            />
          </div>
          
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '8px 16px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting || !duration.trim()}
              style={{
                padding: '8px 16px',
                backgroundColor: isSubmitting ? '#6c757d' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
              }}
            >
              {isSubmitting ? 'Creating...' : 'Create Log'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PatrolLogCreator; 